import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({ providedIn: 'root' })
export class SuperadminGuard {
  constructor(
    private authService: AuthenticationService,
    private router: Router,
  ) {}

  canActivate(): boolean {
    if (!this.authService.isSuperAdmin) return true;
    if (this.authService.selectedCompanyId !== null) return true;

    // Superadmin must select a company first
    this.router.navigate(['/companies']);
    return false;
  }
}
